import axios from 'axios';

const getRequisicoes = params => axios.get('/requisicoes', {
  params,
});

const getRequisicoesList = params => axios.get('/requisicoes/list', {
  params,
});

const getRequisicao = id => axios.get(`/requisicoes/${id}`);

const save = (data) => {
  if (data.id) {
    return axios.put(`requisicoes/${data.id}`, data);
  }
  return axios.post('requisicoes', data);
};

const saveRascunho = (data) => {
  if (data.id) {
    return axios.put(`requisicoes/rascunhos/${data.id}`, data);
  }
  return axios.post('requisicoes/rascunhos', data);
};

const excluirRascunho = id => axios.delete(`requisicoes/rascunhos/${id}`);

const cancelar = id => axios.put(`requisicoes/${id}/cancelar`, {});

const finalizar = id => axios.put(`requisicoes/${id}/finalizar`, {});

const updateIdentifier = (id, requisicao) => axios.put(`/requisicoes/${id}/identifier`, requisicao);

const cancelarProduto = idProduto => axios.put(`requisicoes/produtos/${idProduto}/cancelar`, {});

const finalizarProduto = idProduto => axios.put(`requisicoes/produtos/${idProduto}/finalizar`, {});

const getProdutos = idRequisicao => axios.get(`/requisicoes/${idRequisicao}/produtos`);

const getRequisicoesProdutos = params => axios.get('/requisicoes/produtos', {
  params,
});

const getLinks = id => axios.get(`/requisicoes/${id}/links`);

export default {
  getRequisicoes,
  getRequisicoesList,
  getRequisicao,
  save,
  updateIdentifier,
  cancelar,
  finalizar,
  cancelarProduto,
  finalizarProduto,
  getProdutos,
  getRequisicoesProdutos,
  saveRascunho,
  excluirRascunho,
  getLinks,
};
